<template>
  <div class="catalog-item">
    <div class="container">
      <div class="catalog-item__container">
        <div class="catalog-item__header">
          <div class="catalog-item__header-left">
            <button @click="router.go(-1)" class="catalog-item__back">
              <svg width="8" height="12">
                <use xlink:href="@/assets/icons/sprite.svg#arrowLeft"></use>
              </svg>
            </button>
            <h1>{{ secton.name }}</h1>
          </div>
          <RouterLink to="/search">
            <svg width="36" height="36">
              <use xlink:href="@/assets/icons/sprite.svg#searchBtn"></use>
            </svg>
          </RouterLink>
        </div>
        <div class="catalog-item__list">
          <div v-if="isLoading" class="loader">
            <div class="loader-spinner"></div>
          </div>
          <RouterLink
            v-else
            v-for="item in sections"
            class="catalog-item__link"
            :to="`/catalog/${item.id}`"
            >{{ item.name }}</RouterLink
          >
        </div>
      </div>
    </div>
  </div>
  <CartModal />
</template>
<script setup lang="ts">
  import CartModal from "@/components/CartModal.vue";
  import { ISection, ISectionsItem } from "@/models/models";
  import { ref } from "vue";
  import { useRouter } from "vue-router";

  const router = useRouter();

  const sections = ref<Array<ISectionsItem>>([] as Array<ISectionsItem>);
    
  const secton = ref<ISection>({} as ISection);

  const isLoading = ref(true);

  fetch(`https://akshop.a-dev.xyz/api/v1/sections/${router.currentRoute.value.params.name}`)
    .then((response) => response.json())
    .then((data) => {
      sections.value = data.sections;
      secton.value = data.section;
      isLoading.value = false;
    });
</script>
<style lang="scss">
  .catalog-item {
    &__header {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 32px;

      &-left {
        display: flex;
        align-items: baseline;
        gap: 12px;
      }
    }

    &__back {
      width: 24px;
      height: 24px;
    }

    &__link {
      color: $almostBlack;
    }

    &__list {
      display: flex;
      flex-direction: column;
      gap: 18px;
    }

    @include mediumMobile {
      &__header {
        margin-top: 12px;
        min-height: 36px;
      }
    }
  }
</style>
